<div class="card-header" id="breakdownSolverHeader">
    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
        data-target="#breakdownSolverCollapse" aria-expanded="true" aria-controls="breakdownSolverCollapse">
        Incidents traités par jour
    </button>
</div>
<div id="breakdownSolverCollapse" class="panel-collapse collapse" aria-labelledby="breakdownSolverHeader"
    data-parent="#accordionExtraction">
    <div class="card-body row">
        <div class="wrapper shadowed">
            <br>
            <button type="submit" class="btn btn-primary" style="margin-left: 40px;"
                (click)="onSubmit()">Valider</button>
            <br>
        </div>
        <app-gmao-spinner *ngIf="loading"></app-gmao-spinner>
        <ng-container *ngIf="data">
            <div class="wrapper shadowed">
                <br />
                <h4>Résultats</h4>
                <app-export-button [data]="data"></app-export-button>
                <app-export-button [data]="detail"></app-export-button>
                <br />
                <mat-table [dataSource]="data">
                    <ng-container matColumnDef="jour">
                        <mat-header-cell *matHeaderCellDef> Jour </mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.jour}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nb">
                        <mat-header-cell *matHeaderCellDef> Nb </mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.resolution_nombre}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="user_login">
                        <mat-header-cell *matHeaderCellDef> Utilisateur </mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.user_login}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: ['jour', 'nb', 'user_login'] ;">
                    </mat-row>
                </mat-table>
            </div>
        </ng-container>
        <br />
    </div>
</div>